import type { FaqItem } from '@/types/content';

export const faqItems: FaqItem[] = [
  {
    id: 'faq-1',
    question: '本站的内容主要来自哪里？',
    answer:
      '站内内容由编辑团队根据公开信息、官方声明与网友讨论进行整理与二次梳理，力求把零散的线索拼成可读的时间线。所有话题均以“观察与讨论”的方式呈现，不代表对任何个人或机构的最终结论。',
  },
  {
    id: 'faq-2',
    question: '为什么同一个话题会多次更新？',
    answer:
      '热点事件的进展往往一波三折。我们在话题页记录每次更新的时间与变化，新增信息会以“更新”形式追加，已经发布的内容不会悄悄修改，方便你随时回看完整的来龙去脉。',
  },
  {
    id: 'faq-3',
    question: '看到与自己有关的不实内容怎么办？',
    answer:
      '请通过“联系我们”页面提交说明，并附上可核实的公开材料。核实成立后我们会第一时间更正、补充说明或下架相关内容，并在话题页标注更正记录。',
  },
  {
    id: 'faq-4',
    question: '如何第一时间看到刚上新的内容？',
    answer:
      '首页首屏设有“实时上新”区域，会自动轮播最新进入的内容；下方的实时更新流按时间倒序排列。你可以把本站地址加入浏览器书签，或关注首页顶部的刷新提示，随时掌握最新动态。',
  },
  {
    id: 'faq-5',
    question: '站内的“热度”数值代表什么？',
    answer:
      '热度是一个综合指标，由阅读、讨论、转发与更新频率等多个维度加权得出，用于帮助你判断话题的当前关注度，并非价值判断，也不代表事件本身的重要程度。',
  },
  {
    id: 'faq-6',
    question: '可以投稿或提供线索吗？',
    answer:
      '欢迎。你可以通过联系表单提交线索，请尽量说明信息来源与可核对的时间点。我们会先做真实性判断，再决定是否整理成话题，对于无法核实的内容不会对外发布。',
  },
];